<template>
  <el-row v-loading="loading" type="flex">
    <div>
      <gj-image :src="proxyListing.imageUrl" :size="80"></gj-image>
    </div>
    <div class="listing--base-content">
      <div class="listing--title">
        <div style="max-width: 85%; display: inline-block">
          <gj-tooltip :content="proxyListing.title" :text-line="1" style="display: inline-flex">
            {{ proxyListing.title }}
          </gj-tooltip>
        </div>
        <gj-tag color="#1F6EEF" style="margin-left: 10px" v-if="proxyListing.fulfillment === 'AFN'"
          >FBA</gj-tag
        >
        <gj-tag color="#1F6EEF" style="margin-left: 10px" v-if="proxyListing.fulfillment === 'MFN'"
          >FBM</gj-tag
        >
        <gj-tag color="#FF9900">{{ proxyListing.status }}</gj-tag>
      </div>
      <el-row>
        <el-col :span="8">
          <div class="listing--base-info">
            <span class="gj-listing-label">ASIN</span
            ><span class="gj-listing-content">{{ proxyListing.asin }}</span>
          </div>
          <div class="listing--base-info">
            <span class="gj-listing-label">店铺/国家</span
            ><span class="gj-listing-content"
              >{{ proxyListing.marketName  }}</span
            >
          </div>
        </el-col>
        <el-col :span="8">
          <div class="listing--base-info">
            <span class="gj-listing-label">MSKU</span
            ><span class="gj-listing-content">{{ proxyListing.msku }}</span>
          </div>
          <div class="listing--base-info">
            <gj-tooltip
              :text-line="1"
              style="display: inline-flex"
              :content="proxyListing.productName"
              placement="top"
            >
              <span class="gj-listing-label">产品名称</span>
              <span class="gj-listing-content">
                {{ proxyListing.productName || '-' }}
              </span>
            </gj-tooltip>
          </div>
        </el-col>
        <el-col :span="8">
          <div class="listing--base-info">
            <span class="gj-listing-label">父ASIN</span
            ><span class="gj-listing-content">{{ proxyListing.variationAsin || '-' }}</span>
          </div>
          <div class="listing--base-info">
            <span class="gj-listing-label">SKU</span
            ><span class="gj-listing-content">{{ proxyListing.sku || '-' }}</span>
          </div>
        </el-col>
      </el-row>
    </div>
  </el-row>
</template>

<script>
import { isMeaningful, isMeaningless } from '../../../../../utils/common';
import { getListingDetail } from '../../../../../api/sale';

export default {
  name: 'app-listing-header',
  props: {
    id: {
      required: false,
    },
    listing: {
      default: () => {},
    },
  },
  data() {
    return {
      proxyListing: {},
      loading: false,
    };
  },
  watch: {
    listing: {
      handler: function (val) {
        this.proxyListing = val || {};
      },
      immediate: true,
    },
  },
  created() {
    if (isMeaningless(this.listing) && isMeaningful(this.id)) {
      this.getListing();
    }
  },
  methods: {
    getListing() {
      this.loading = true;
      getListingDetail(this.id)
        .then((data) => {
          this.proxyListing = data;
        })
        .complete(() => (this.loading = false));
    },
  },
};
</script>

<style scoped>
.listing--base-content {
  padding: 0 10px 0 20px;
  flex: 1;
}
.listing--title {
  margin-bottom: 10px;
  font-size: 13px;
  font-weight: bold;
  color: #333;
}
.listing--base-info {
  margin-bottom: 12px;
  font-size: 14px;
  color: rgba(0, 0, 0, 0.65);
}
.gj-listing-label {
  color: #666;
  font-size: 12px;
  display: inline-block;
  width: 60px;
  text-align: right;
  margin-right: 12px;
}
.gj-listing-content {
  color: #333;
  font-size: 12px;
}
</style>
